import React from "react";
import { currencyUSD } from "../../helpers/forms/formater";
import { Pencil, Trash2 } from "lucide-react";

const Columns = (addUpd) => {
    let columns = [
        {
            id: "code",
            name: "No",
            selector: (row) => `${row.code}`,
        },
        {
            id: "name",
            name: "Nombre",
            selector: (row) => `${row.name}`,
        },
        {
            id: "sales_quarter",
            name: "Ventas de la 15na",
            selector: (row) => (
                <span className="text-fr-accent font-semibold bg-fr-accent/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_quarter ?? 0)}
                </span>
            ),
        },
        {
            id: "sales_month",
            name: "Ventas del mes",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_month ?? 0)}
                </span>
            ),
        },
        {
            id: "acciones",
            name: "Acciones",
            selector: (row) => (
                <div className="flex items-center gap-3">
                    <button
                        className="text-fr-primary hover:text-fr-primary-hover transition"
                        onClick={() => addUpd(row)}
                        title="Editar"
                    >
                        <Pencil size={18} />
                    </button>
                </div>
            ),
        },
    ];
    return columns;
};

export default Columns;
